import React, { useEffect, useState } from 'react';
import Footer from '@/components/UI/Footer';
import '@arco-design/web-react/dist/css/arco.css';
import LoginForm from './form';
import LoginBanner from './banner';
import './style/style.less';
import loginimg from '@/assets/Logo/logo.png';
import minimize from '@/assets/login/minimize.png';
import zoom_max from '@/assets/login/zoom_max.png';
import zoom_min from '@/assets/login/zoom_min.png';
import close from '@/assets/login/close.png';
import transparentLogo from '@/assets/transparent_logo.png';

import { observer } from 'mobx-react-lite';
import LoadingGIF from '@/components/UI/LoadingGIF';
import { useHistory } from 'react-router-dom';
import { appStore } from '@/mobx';
function Login() {
  const history = useHistory();
  const [count, setCount] = useState(0);
  const [submitTime] = useState('2024-11-28 20:33/test');
  const [isMaximized, setIsMaximized] = useState(false);

  const checkAppleSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    // 使用类型断言来绕过类型检查
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return true;
    } else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
      return true;
    } else {
      return false;
    }
  };
  const handleMinimize = () => {
    window.electron.ipcRenderer.windowControl.minimize();
  };

  const handleMaximize = () => {
    window.electron.ipcRenderer.windowControl.maximize();
  };

  const handleClose = () => {
    window.electron.ipcRenderer.windowControl.close();
  };
  useEffect(() => {
    // window.localStorage.clear();
  }, []);
  useEffect(() => {
    // 监听主进程传来的窗口状态变化
    if (window && window.electron) {
      window.electron.ipcRenderer.windowStateChanged((state) => {
        setIsMaximized(state);
      });
    }

    // 清理事件监听器
    return () => {
      if (window && window.electron) {
        window.electron.ipcRenderer.removeListener(
          'window-state-changed',
          () => {
            //
          }
        );
      }
    };
  }, []);
  // const [search] = useSearchParams();
  // const adminToken = search.get('token');
  // useEffect(() => {
  //   if (adminToken) {
  //     window.localStorage.clear();
  //     window.localStorage.setItem('Token', adminToken);
  //     history.push('/');
  //   }
  // }, [adminToken]);
  return (
    <div className="container">
      {window && window.electron ? (
        <div
          className="clent-tool"
          style={{ display: checkAppleSystem() ? 'none' : 'flex' }}
        >
          <div onClick={handleMinimize}>
            <img src={minimize} alt="" />
          </div>
          <div onClick={handleMaximize}>
            <img src={isMaximized ? zoom_min : zoom_max} alt="" />
          </div>
          <div onClick={handleClose}>
            <img src={close} alt="" />
          </div>
        </div>
      ) : (
        <></>
      )}

      <>
        <div
          className="version"
          onClick={() => {
            setCount(count + 1);
          }}
        >
          {count > 10 ? submitTime : ''}
        </div>
        <div className="logo">
          <img
            src={
              appStore.isZhaiXing
                ? transparentLogo
                : appStore.config?.web?.app?.transparent_logo
            }
            className="login_contel_itemIMG"
            alt=""
          />
        </div>
        <div className="banner">
          <div className="inner">
            <LoginBanner />
          </div>
        </div>
        <div className="content">
          <div className="inner">
            <div>&emsp;</div>
            <div>&emsp;</div>
            <LoginForm />
            <div className="icp-info">
              {appStore.config?.web?.app?.copyright_text}&emsp;|&emsp;
              <a
                rel="noreferrer"
                target="_blank"
                href="https://beian.miit.gov.cn"
                style={{ color: '#9e9e9e' }}
              >
                {appStore.config?.web?.app?.icp_date}
              </a>
              {/* &emsp;|&emsp;
                  <img src={badge} width={13} alt="" />
                  &nbsp; {appStore.config?.web?.app?.icp_no} */}
            </div>
          </div>
          <div className="footer">
            <Footer />
          </div>
        </div>
      </>
    </div>
  );
}
Login.displayName = 'LoginPage';

export default observer(Login);
